/* Dabrana · cinematic layer. The splash overlay is server-rendered inline in layout/theme.liquid so it paints on the FIRST frame (no flash of the next page) and self-dismisses via pure CSS. This script only removes it after the fade, then adds scroll reveal + band parallax + AJAX cart. */
(function(){
  function init(){
    var sp=document.getElementById('dh-splash');
    if(sp){setTimeout(function(){if(sp.parentNode)sp.parentNode.removeChild(sp);},2200);}
    var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
    document.querySelectorAll('.dh [data-reveal]').forEach(function(el){
      var kids=el.querySelectorAll(':scope > *');
      if(kids.length>1&&kids.length<9){for(var i=0;i<kids.length;i++){kids[i].style.transition='opacity .8s cubic-bezier(0.22,1,0.36,1) '+(i*90)+'ms,transform .8s cubic-bezier(0.22,1,0.36,1) '+(i*90)+'ms';}}
    });
    var bands=[].slice.call(document.querySelectorAll('.pdp-band img'));
    if(bands.length&&!reduce){
      bands.forEach(function(b){b.classList.add('dh-parallax');});
      var ticking=false;
      function upd(){bands.forEach(function(b){var r=b.getBoundingClientRect();var vh=innerHeight;if(r.bottom>0&&r.top<vh){var p=((r.top+r.height/2)-vh/2)/vh;b.style.transform='translateY('+(p*-24).toFixed(1)+'px) scale(1.06)';}});ticking=false;}
      addEventListener('scroll',function(){if(!ticking){requestAnimationFrame(upd);ticking=true;}},{passive:true});upd();
    }
    /* Sticky mobile Add-to-Cart: the .dh wrapper keeps a residual identity transform (from its dh-enter fill animation), which turns it into the containing block for position:fixed — so the sticky bar stopped tracking the viewport and only parked at the page bottom. Re-home it in a fresh .dh host on <body> with animation/transform neutralised, so it inherits the design tokens (gold button etc.) yet its position:fixed resolves against the viewport again. */
    var stk=document.getElementById('pdp-sticky');
    if(stk&&!(stk.parentNode&&stk.parentNode.id==='dab-sticky-host')){
      var host=document.createElement('div');
      host.className='dh';host.id='dab-sticky-host';
      host.style.animation='none';host.style.transform='none';
      document.body.appendChild(host);
      host.appendChild(stk);
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

/* Dabrana · AJAX Add to Cart — intercept product forms site-wide so items add without leaving the page. */
(function(){
  var toastEl;
  function toast(msg,isErr){
    if(!toastEl){
      toastEl=document.createElement('div');
      toastEl.id='dab-cart-toast';
      toastEl.style.cssText='position:fixed;left:50%;bottom:26px;transform:translateX(-50%) translateY(20px);z-index:100001;'+
        'background:rgba(20,17,12,.96);color:#F4DDA6;border:1px solid rgba(201,161,90,.4);'+
        'font-family:Inter,system-ui,sans-serif;font-size:13px;letter-spacing:.04em;'+
        'padding:12px 22px;border-radius:999px;box-shadow:0 12px 44px rgba(0,0,0,.5);'+
        'opacity:0;transition:opacity .3s ease,transform .3s ease;pointer-events:none;display:flex;align-items:center;gap:9px;max-width:88vw';
      document.body.appendChild(toastEl);
    }
    var icon=isErr?'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#E0736B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16v.01"/></svg>':'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7FCB8E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
    toastEl.innerHTML=icon+'<span>'+msg+'</span>';
    requestAnimationFrame(function(){toastEl.style.opacity='1';toastEl.style.transform='translateX(-50%) translateY(0)';});
    clearTimeout(toastEl._t);
    toastEl._t=setTimeout(function(){toastEl.style.opacity='0';toastEl.style.transform='translateX(-50%) translateY(20px)';},2600);
  }
  function cartLinks(){return document.querySelectorAll('a[href="/cart"],a[href$="/cart"],a[aria-label="Cart"]');}
  function updateCount(count){
    cartLinks().forEach(function(a){
      if(getComputedStyle(a).position==='static')a.style.position='relative';
      var b=a.querySelector('.dab-cart-count');
      if(!count){if(b)b.parentNode.removeChild(b);return;}
      if(!b){
        b=document.createElement('span');
        b.className='dab-cart-count';
        b.style.cssText='position:absolute;top:-6px;right:-8px;min-width:16px;height:16px;padding:0 4px;'+
          'background:var(--accent,#C9A15A);color:#0B0A08;border-radius:999px;font-family:Inter,system-ui,sans-serif;'+
          'font-size:10px;font-weight:600;line-height:16px;text-align:center;box-sizing:border-box;pointer-events:none';
        a.appendChild(b);
      }
      b.textContent=count;
    });
  }
  function syncCount(){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){updateCount(c.item_count);}).catch(function(){});}

  /* ⚠ THE ADD-TO-CART SUBMIT HANDLER THAT USED TO LIVE HERE HAS BEEN REMOVED — 29 Aug 2026.
     It was a capture-phase 'submit' listener that called preventDefault() and POSTed to
     /cart/add.js. assets/dab-cart.js later grew its own capture-phase handler doing exactly
     the same POST. Both are registered on document in the CAPTURE phase, and this file is
     loaded FIRST by layout/theme.liquid, so this one ran first, cancelled the native submit,
     added the item — and then, because it never called stopImmediatePropagation(), the
     dab-cart.js listener ran too and added the SAME item a second time. One tap, quantity 2.
     dab-cart.js is now the single owner of adding to cart: it also skips #pdp-buynow (the
     Shiprocket route), skips Fastrr subtrees and the drawer, and handles sold-out variants.
     ⚠ DO NOT re-add a /cart/add listener in this file. If the add flow needs changing, change
     the one in dab-cart.js. The toast is exported below so dab-cart.js can still use it. */
  window.__dabToast = toast;
  window.__dabSyncCount = syncCount;

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',syncCount);else syncCount();
})();

/* Dabrana · Back-to-Top — small gold arrow, bottom-right, fades in after scrolling, smooth-scrolls to top. Site-wide. */
(function(){
  function init(){
    if(document.getElementById('dab-top'))return;
    var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
    var btn=document.createElement('button');
    btn.id='dab-top';
    btn.type='button';
    btn.setAttribute('aria-label','Back to top');
    btn.innerHTML='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5"/><path d="M5 12l7-7 7 7"/></svg>';
    btn.style.cssText='position:fixed;right:20px;bottom:22px;z-index:99998;width:46px;height:46px;'+
      'display:flex;align-items:center;justify-content:center;'+
      'background:rgba(20,17,12,.92);color:var(--accent,#C9A15A);'+
      'border:1px solid rgba(201,161,90,.42);border-radius:999px;cursor:pointer;'+
      'box-shadow:0 10px 34px rgba(0,0,0,.44);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);'+
      'opacity:0;visibility:hidden;transform:translateY(14px) scale(.92);'+
      'transition:opacity .35s ease,transform .35s ease,visibility .35s ease,background .25s ease,color .25s ease';
    btn.addEventListener('mouseenter',function(){btn.style.background='var(--accent,#C9A15A)';btn.style.color='#0B0A08';});
    btn.addEventListener('mouseleave',function(){btn.style.background='rgba(20,17,12,.92)';btn.style.color='var(--accent,#C9A15A)';});
    btn.addEventListener('click',function(){window.scrollTo({top:0,behavior:reduce?'auto':'smooth'});});
    document.body.appendChild(btn);
    var shown=false,ticking=false;
    function upd(){var y=window.pageYOffset||document.documentElement.scrollTop;var want=y>420;if(want!==shown){shown=want;btn.style.opacity=want?'1':'0';btn.style.visibility=want?'visible':'hidden';btn.style.transform=want?'translateY(0) scale(1)':'translateY(14px) scale(.92)';}ticking=false;}
    addEventListener('scroll',function(){if(!ticking){requestAnimationFrame(upd);ticking=true;}},{passive:true});
    upd();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

/* Dabrana · Hero banner reliability. The homepage hero (desktop .dh-hero + mobile .dh-mhero) auto-rotates every few seconds, and slides 2 & 3 were marked loading="lazy". Because each slide's own background is solid black, any slide whose image had not finished downloading when the slideshow rotated onto it showed as a BLACK frame. This forces every hero image to load immediately (eager), and — as a safety net — if a resized CDN variant (…?width=NNNN) ever fails to decode, it retries the original untransformed file so a banner can never fall back to black. */
(function(){
  function fixHero(){
    var imgs=document.querySelectorAll('.dh-hero__s img,.dh-mhero__s img');
    if(!imgs.length)return;
    for(var i=0;i<imgs.length;i++){
      (function(img){
        try{img.loading='eager';}catch(e){}
        img.setAttribute('decoding','async');
        if(!img.dataset.dabHeroFix){
          img.dataset.dabHeroFix='1';
          img.addEventListener('error',function(){
            var s=img.getAttribute('src')||'';
            if(/[?&]width=\d+/.test(s)){
              var clean=s.replace(/([?&])width=\d+/,'$1').replace(/[?&]$/,'');
              if(clean!==s)img.src=clean;
            }
          });
        }
        /* nudge the fetch to start now if it hasn't */
        if(!img.complete){var src=img.getAttribute('src');if(src)img.src=src;}
      })(imgs[i]);
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fixHero);else fixHero();
  addEventListener('load',fixHero);
})();

/* Dabrana · Hide the Journal / blog link from the site header on EVERY page (home, product, collection, page, blog, article + any future page). Rationale: keep shoppers who arrive via a blog in the shopping flow, and keep shoppers browsing products from being pulled into the blog — both help conversion. Injected as an early <style> (no flash) plus DOM removal as a safety net. Footer links are intentionally left untouched. */
(function(){
  try{
    var st=document.createElement('style');
    st.id='dab-hide-journal';
    st.textContent='.dh-head nav a[href*="/blogs/"]{display:none!important}';
    (document.head||document.documentElement).appendChild(st);
  }catch(e){}
  function strip(){
    var links=document.querySelectorAll('.dh-head nav a[href*="/blogs/"]');
    for(var i=0;i<links.length;i++){if(links[i].parentNode)links[i].parentNode.removeChild(links[i]);}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',strip);else strip();
})();

/* Dabrana · Mobile menu — hamburger + slide-in drawer. On phones (<=600px) the header hides its inline nav, so add a 3-line menu button at the far left, nudge the Scent Profiler pill right (compacting it to its gold sparkle + New badge so it clears the centred logo), and open a dark gold-accented drawer with the primary links incl. the two gift pages. Desktop is untouched. */
(function(){
  var LINKS=[['Home','/'],['All Collection','/collections/all'],['Our Story','/pages/dabrana-our-story'],['Gift For Her','/pages/gift-for-her'],['Gift For Him','/pages/gift-for-him']];
  function css(){
    if(document.getElementById('dab-menu-css'))return;
    var s=document.createElement('style');s.id='dab-menu-css';
    s.textContent='.dab-ham{display:none;position:absolute;left:12px;top:50%;transform:translateY(-50%);z-index:7;width:30px;height:30px;flex-direction:column;align-items:center;justify-content:center;gap:5px;background:none;border:0;padding:0;cursor:pointer}'
    +'.dab-ham span{display:block;width:21px;height:1.5px;background:var(--text-strong,#F5EFE3);border-radius:2px}'
    +'@media(max-width:600px){.dab-ham{display:flex}.dh-head__profiler{left:50px!important;padding:6px 8px!important}.dh-head__profiler .dh-head__profiler-main span{display:none!important}}'
    +'#dab-drawer{position:fixed;inset:0;z-index:100000;visibility:hidden;pointer-events:none}'
    +'#dab-drawer .dab-scrim{position:absolute;inset:0;background:rgba(6,5,4,.62);opacity:0;transition:opacity .35s ease}'
    +'#dab-drawer .dab-panel{position:absolute;top:0;left:0;height:100%;width:min(80vw,320px);background:var(--bg,#0B0A08);border-right:1px solid var(--hairline,rgba(201,161,90,.2));box-shadow:24px 0 60px rgba(0,0,0,.5);transform:translateX(-102%);transition:transform .38s cubic-bezier(.22,1,.36,1);display:flex;flex-direction:column;padding:20px 0 28px;overflow-y:auto}'
    +'#dab-drawer.is-open{visibility:visible;pointer-events:auto}'
    +'#dab-drawer.is-open .dab-scrim{opacity:1}'
    +'#dab-drawer.is-open .dab-panel{transform:translateX(0)}'
    +'.dab-panel__top{display:flex;align-items:center;justify-content:space-between;padding:2px 18px 18px;border-bottom:1px solid var(--hairline,rgba(201,161,90,.16))}'
    +'.dab-panel__top img{width:96px;height:auto}'
    +'.dab-close{width:38px;height:38px;display:flex;align-items:center;justify-content:center;background:none;border:0;color:var(--text-strong,#F5EFE3);cursor:pointer;border-radius:999px}'
    +'.dab-panel nav{display:flex;flex-direction:column;padding:6px 0}'
    +'.dab-panel nav a{font-family:var(--font-sans,Inter,system-ui,sans-serif);font-size:14px;letter-spacing:.14em;text-transform:uppercase;color:color-mix(in srgb,var(--text-strong,#F5EFE3) 84%,transparent);text-decoration:none;padding:17px 22px;border-bottom:1px solid color-mix(in srgb,var(--hairline,#C9A15A) 55%,transparent);transition:color .2s ease,background .2s ease}'
    +'.dab-panel nav a:hover,.dab-panel nav a:focus{color:var(--gold,#C9A15A);background:color-mix(in srgb,var(--gold,#C9A15A) 8%,transparent)}';
    (document.head||document.documentElement).appendChild(s);
  }
  var drawer;
  function build(){
    if(drawer)return drawer;
    css();
    drawer=document.createElement('div');drawer.id='dab-drawer';drawer.setAttribute('role','dialog');drawer.setAttribute('aria-label','Menu');
    var logo=(document.querySelector('.dh-logo img')||{}).src||'';
    var nav='';for(var i=0;i<LINKS.length;i++){nav+='<a href="'+LINKS[i][1]+'">'+LINKS[i][0]+'</a>';}
    drawer.innerHTML='<div class="dab-scrim" data-close></div><div class="dab-panel"><div class="dab-panel__top">'+(logo?'<img src="'+logo+'" alt="Dabrana">':'<span></span>')+'<button class="dab-close" type="button" aria-label="Close menu" data-close><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div><nav>'+nav+'</nav></div>';
    document.body.appendChild(drawer);
    drawer.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('[data-close]'))close();});
    return drawer;
  }
  function open(){build().classList.add('is-open');document.documentElement.style.overflow='hidden';}
  function close(){if(drawer){drawer.classList.remove('is-open');document.documentElement.style.overflow='';}}
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  function mount(){
    css();
    var heads=document.querySelectorAll('.dh-head');
    for(var i=0;i<heads.length;i++){var h=heads[i];if(h.querySelector('.dab-ham'))continue;var b=document.createElement('button');b.type='button';b.className='dab-ham';b.setAttribute('aria-label','Open menu');b.innerHTML='<span></span><span></span><span></span>';b.addEventListener('click',open);h.insertBefore(b,h.firstChild);}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
})();

/* Dabrana · Swipeable hero banners (2026-08-23). Both the desktop hero (#dh-hero) and the mobile
   hero (#dh-mhero) are opacity-crossfade stacks driven by their dot rows. Swipe/drag left or right
   here simply synthesizes a click on the neighbouring dot, so the existing go()+timer-reset logic
   in dab-home.liquid stays the single source of truth (no duplicated rotator, no drift).
   Vertical intent is released immediately so page scrolling is never captured; a short guard after
   a real swipe swallows the trailing click so the banner link doesn't fire. */
(function(){
  var THRESH=45;
  function wire(root,dotSel){
    if(!root||root.__dabSwipe)return;
    var dots=document.querySelectorAll(dotSel);
    if(dots.length<2)return;
    root.__dabSwipe=1;
    function cur(){for(var k=0;k<dots.length;k++){if(dots[k].classList.contains('is-active'))return k;}return 0;}
    var syn=false;
    function step(dir){var n=dots.length;syn=true;dots[(cur()+dir+n)%n].click();syn=false;}
    var sx=0,sy=0,dx=0,axis=0,live=false,guard=0;
    function begin(x,y){sx=x;sy=y;dx=0;axis=0;live=true;}
    function move(x,y,e){
      if(!live)return;
      dx=x-sx;var dy=y-sy;
      if(!axis&&(Math.abs(dx)>10||Math.abs(dy)>10))axis=Math.abs(dx)>Math.abs(dy)?1:2;
      if(axis===2){live=false;root.style.cursor='';return;}
      if(axis===1){if(e&&e.cancelable)e.preventDefault();root.style.cursor='grabbing';}
    }
    function end(){
      root.style.cursor='';
      if(!live)return;
      live=false;
      if(axis===1&&Math.abs(dx)>THRESH){step(dx<0?1:-1);guard=Date.now()+450;}
    }
    root.addEventListener('touchstart',function(e){if(e.touches.length>1){live=false;return;}begin(e.touches[0].clientX,e.touches[0].clientY);},{passive:true});
    root.addEventListener('touchmove',function(e){if(e.touches.length)move(e.touches[0].clientX,e.touches[0].clientY,e);},{passive:false});
    root.addEventListener('touchend',end);
    root.addEventListener('touchcancel',function(){live=false;root.style.cursor='';});
    root.addEventListener('mousedown',function(e){if(e.button!==0)return;begin(e.clientX,e.clientY);e.preventDefault();});
    document.addEventListener('mousemove',function(e){if(live)move(e.clientX,e.clientY,null);});
    document.addEventListener('mouseup',function(){if(live)end();});
    root.addEventListener('click',function(e){if(!syn&&Date.now()<guard){e.preventDefault();e.stopPropagation();}},true);
    root.addEventListener('dragstart',function(e){e.preventDefault();});
  }
  function mount(){
    wire(document.getElementById('dh-hero'),'#dh-dots button');
    wire(document.getElementById('dh-mhero'),'#dh-mdots button');
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
  setTimeout(mount,1200);
})();
